import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            选择您感兴趣的内容分类，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group bg-background-50 rounded-lg p-6 md:p-7 cursor-pointer border border-background-200 hover:border-primary-300 transition-all duration-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                  <i className={`${category.icon} text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200">
                    {category.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {category.description}
                  </p>
                  <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                    <i className="ri-article-line" />
                    <span>{category.articleCount} 篇文章</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}